






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Txt extends Vue {
  @Prop() color!: string;
  @Prop() font!: string;
  @Prop() text!: string;

  get fontStyle() {
    return {
      color: this.color,
      fontFamily: this.font,
    };
  }
}
